/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdatePlanRequest
 */
export interface UpdatePlanRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdatePlanRequest
     */
    plan: UpdatePlanRequestPlanEnum;
    /**
     * 
     * @type {string}
     * @memberof UpdatePlanRequest
     */
    paymentFrequency: UpdatePlanRequestPaymentFrequencyEnum;
    /**
     * 
     * @type {string}
     * @memberof UpdatePlanRequest
     */
    locationId?: string;
}


/**
 * @export
 */
export const UpdatePlanRequestPlanEnum = {
    Starter: 'starter',
    Growth: 'growth',
    Unlimited: 'unlimited'
} as const;
export type UpdatePlanRequestPlanEnum = typeof UpdatePlanRequestPlanEnum[keyof typeof UpdatePlanRequestPlanEnum];

/**
 * @export
 */
export const UpdatePlanRequestPaymentFrequencyEnum = {
    Monthly: 'monthly',
    Yearly: 'yearly'
} as const;
export type UpdatePlanRequestPaymentFrequencyEnum = typeof UpdatePlanRequestPaymentFrequencyEnum[keyof typeof UpdatePlanRequestPaymentFrequencyEnum];


/**
 * Check if a given object implements the UpdatePlanRequest interface.
 */
export function instanceOfUpdatePlanRequest(value: object): value is UpdatePlanRequest {
    if (!('plan' in value) || value['plan'] === undefined) return false;
    if (!('paymentFrequency' in value) || value['paymentFrequency'] === undefined) return false;
    return true;
}

export function UpdatePlanRequestFromJSON(json: any): UpdatePlanRequest {
    return UpdatePlanRequestFromJSONTyped(json, false);
}

export function UpdatePlanRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdatePlanRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'plan': json['plan'],
        'paymentFrequency': json['paymentFrequency'],
        'locationId': json['locationId'] == null ? undefined : json['locationId'],
    };
}

export function UpdatePlanRequestToJSON(json: any): UpdatePlanRequest {
    return UpdatePlanRequestToJSONTyped(json, false);
}

export function UpdatePlanRequestToJSONTyped(value?: UpdatePlanRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'plan': value['plan'],
        'paymentFrequency': value['paymentFrequency'],
        'locationId': value['locationId'],
    };
}

